import React, { Component } from 'react';
import { Input, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';

class ArchkNull extends Component {

    state = {

    };

    onChange = (e) => {

        let value = e.target.value

        this.setState({value})

        if(this.props.onChange) {

            if(value) {
                this.props.onChange(`${value}{exists}`)
            } else {
                this.props.onChange()
            }

        }

    }

    render() {

        const { label } = this.props

        return (

            <FormGroup>

                {label ? ( <label className="form-control-label mb-0">{label}</label> ) : null}

                <div className="archk-select">
                    <Input
                        // value={this.state.value || ''}
                        onChange={this.onChange}
                        type="select"
                    >

                        <option></option>

                        <option value="true">Yes</option>
                        <option value="false">No</option>

                    </Input>

                </div>

            </FormGroup>

        )

    }

}

ArchkNull.propTypes = {

    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,

}

export default ArchkNull;
